import * as React from "react"
import {Grid, Skeleton} from "@mui/material";

import CustomDashboardsPrimorFlashOffersOffersTable from "./Table";
import {customDashboardsPrimorTabID} from "../@signals";
import {TABS_OFFERS} from "../@constants";


export default function CustomDashboardsPrimorFlashOffersOffersTabTable({tabID, isLoading, data, handleExcel, handleChangeReloadData}) {
	 if (tabID !== customDashboardsPrimorTabID.value)
		return <></>

	if (!isLoading && !data.length && tabID === TABS_OFFERS.DRUNI )
		return <></>

    return <Grid item xs={12}>
        { isLoading
            ? <Skeleton variant="rectangular" height={700} />
            : <CustomDashboardsPrimorFlashOffersOffersTable
                title={tabID}
                data={data}
				handleChangeReloadData={handleChangeReloadData}
                onDownload={handleExcel}
            />
        }
    </Grid>
}